<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" lg="12">
        <v-row style="padding: 0% 6% 0% 6%;">
          <v-col md="8" sm="12" style="text-align: left;">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title
                  class="headline"
                >
                  <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.raceDetails.event')"
                      v-model="eventName"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('eventName')"
                    ></v-text-field>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.raceDetails.race_name')"
                      v-model="raceName"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('raceName')"
                    ></v-text-field>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.raceDetails.scoring_mode')"
                      v-model="raceDetails.modeName"
                      style="margin: 10px 0"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                    <v-text-field
                      hide-details="auto"
                      :label="$tc('dashboard.menu.raceDetails.track_length')"
                      v-model="raceDetails.trackLength"
                      style="margin: 10px 0"
                      outlined
                      dense
                      readonly
                    ></v-text-field>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                    <v-menu v-model="menu_['startDay']" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$tc('dashboard.menu.raceDetails.start_day')"
                          v-model="startDay"
                          style="margin: 10px 0"
                          :append-icon="'fa-calendar'"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="300" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-date-picker
                            v-model="startDay"
                            @change="saveDate"
                            :header-date-format="$datePicker.formatDateHeader"
                            :title-date-format="$datePicker.formatTitleDate"
                            :weekday-format="$datePicker.formatWeekday"
                            :month-format="$datePicker.formatMonth"
                          ></v-date-picker>
                        </div>
                      </v-card>
                    </v-menu>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                    <v-menu v-model="menu_['startTime']" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$tc('dashboard.menu.raceDetails.start_time')"
                          v-model="startTime"
                          style="margin: 10px 0"
                          :append-icon="'fa-clock'"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="320" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-time-picker
                          v-model="startTime"
                          @change="saveTime"
                        ></v-time-picker>
                        </div>
                      </v-card>
                    </v-menu>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                    <v-menu v-model="menu_['raceLength']" :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          hide-details="auto"
                          :label="$tc('dashboard.menu.raceDetails.race_length')"
                          v-model="startTime"
                          style="margin: 10px 0"
                          :append-icon="'fa-clock'"
                          v-bind="attrs" 
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>

                      <v-card height="auto" width="320" style="padding: 2%" class="text-input-date">
                        <div>
                          <v-time-picker
                          v-model="raceLength"
                          @change="saveTime"
                        ></v-time-picker>
                        </div>
                      </v-card>
                    </v-menu>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                        <v-select
                          :items="statusItems"
                          v-model="status"
                          style="margin: 10px 0"
                          dense
                          outlined
                          :label="$tc('dashboard.menu.raceDetails.status')"
                          return-object
                          :no-data-text="$t('common.no_data')"
                        >
                          <template v-slot:item="{item}">
                            <div v-html="item.text" />
                          </template>
                          <template v-slot:selection="{item}">
                            <div v-html="item.text" />
                          </template>
                        </v-select>
                </v-list-item-title>
                <v-list-item-title
                  class="headline"
                >
                        <v-select
                          :items="droItems"
                          v-model="dro_"
                          style="margin: 10px 0"
                          item-text="text"
                          item-value="id"
                          dense
                          outlined
                          :label="$tc('dashboard.menu.raceDetails.dro')"
                          return-object
                          :no-data-text="$t('common.no_data')"
                        >
                          <template v-slot:item="{item}">
                            <div v-html="item.text" />
                          </template>
                          <template v-slot:selection="{item}">
                            <div v-html="item.text" />
                          </template>
                        </v-select>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col md="4" sm="12">
            <v-row>
              <v-col cols="12" md="12" lg="12">
                <v-img height="100%" width="100%" :src="imageUrl" v-on:error="ImgError"></v-img>
              </v-col>
              <v-col cols="12" md="12" lg="12">
                <v-btn
                  style="width:100%;"
                  class="ma-2"
                  outlined
                  @click="upload()"
                >{{ $tc('dashboard.menu.raceDetails.change_your_image') }}</v-btn>
                <input
                  style="display:none;"
                  type="file"
                  id="uploadImage_"
                  name="uploadImage_"
                  accept="image/*"
                  @change="onImageChange($event)"
                  multiple
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <SGSNotificationConfirm v-if="alertError" :notificationMessage="msg" 
    @cancel="alertError=false;" type="error" :reject="$t('common.form.cancel')"/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";
import axios from "axios";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import { YES_NO_OPTIONS } from "@/constants/selectOptions.js";  

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  components: {
    SGSNotificationConfirm
  },
  data() {
    return {
      navigationBGColor: "#FFF",
      menu_: [
        { eventName: false },
        { raceName: false },
        { startDay: false },
        { startTime: false },
        { raceLength: false },
        { status: false },
        { dro: false }
      ],
      eventName: null,
      eventName_: null,
      raceName: null,
      startDay: null,
      startTime: null,
      raceLength: null,
      status: null,
      dro: null,
      dro_: null,
      imageUrl: null,
      eventId: null,
      raceDetails: [],
      isPromoter: null,
      failed_image: true,
      msg: '',
      alertError: false
    };
  },
  computed: {
    statusItems() {
      return [
        { id: 0, text: this.$t("dashboard.menu.raceDetails.to_be_started") },
        { id: 1, text: this.$t("dashboard.menu.raceDetails.live") },
        { id: 2, text: this.$t("dashboard.menu.raceDetails.un_official") },
        { id: 3, text: this.$t("dashboard.menu.raceDetails.official_results") },
        { id: 4, text: this.$t("dashboard.menu.raceDetails.testing") }
      ];
    },
    droItems() {
      return YES_NO_OPTIONS(this);
    }
  },
  created: function() {
    this.navigationBGColor = process.env.VUE_APP_HEADER_COLOR;
  },
  asyncComputed: {
    eventName: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/race/getEventByRaceId/" +
          this.$route.params.id
      );

      if (response.success == 1) {
        this.eventId = response.message;

        var response_ = await this.api(
          "get",
          "/api/v1/promoter/race/getEvent/" + this.eventId
        );
        this.eventName_ = response_.message[0].eventName;
        return response_.message[0].eventName;
      } else return "";
    },
    isPromoter: async function() {
      var userDetails = await this.api(
        "get",
        "/api/v1/promoter/race/getUser"
      );

      if (userDetails.success == 1) {
        var isPromoter = userDetails.message[0].areaId == 2 ? true : false;

        let data = {};
        let response = [];

        /*if (isPromoter) {
          // I need think about this...

          data.raceId = this.$route.params.id;
          data.force = true;

          response = await this.postApi(
            "/api/v1/promoter/race",
            data
          );
        } else {*/
          data.raceId = this.$route.params.id;
          data.force = true;

          response = await this.postApi(
            "/api/v1/promoter/race",
            data
          );
        //}
        if (response.success == 1) {
          response.message.raceName =
            response.message.raceName != undefined
              ? response.message.raceName
              : "";

          response.message.modeName =
            response.message.modeName != undefined
              ? response.message.modeName
              : "";
          response.message.trackLength =
            response.message.trackLength != undefined
              ? response.message.trackLength
              : "";

          response.message.startDay =
            response.message.startDay != undefined &&
            response.message.startDay != null &&
            response.message.startDay != ""
              ? response.message.startDay
              : "0000-00-00";

          response.message.startTime =
            response.message.startTime != undefined &&
            response.message.startTime != null &&
            response.message.startTime != ""
              ? response.message.startTime
              : "00:00:00";

          response.message.raceLength =
            response.message.raceLength != undefined &&
            response.message.raceLength != null &&
            response.message.raceLength != ""
              ? response.message.raceLength
              : "00:00:00";

          this.raceName = response.message.raceName;
          this.startDay = response.message.startDay;
          this.startTime = response.message.startTime;
          this.raceLength = response.message.raceLength;
          this.status = response.message.status;

          this.imageUrl = response.message.existFile
            ? process.env.VUE_APP_ROOT +
              "/laravel/public/" +
              response.message.trackImage
            : this.failed_image
            ? process.env.VUE_APP_ROOT + response.message.trackImage
            : require("@/assets/images/orgPlaceholder.jpg.png");

          this.raceDetails = response.message;

          return isPromoter;
        } else return [];
      } else return [];
    },
    dro: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/race/getDisplayFlag/" +
          this.$route.params.id
      );

      this.dro_ = response.message.displayFlag == 1 ? 1 : 0;

      return response.message.displayFlag == 1
        ? this.$t("dashboard.menu.raceDetails.yes")
        : this.$t("dashboard.menu.raceDetails.no");
    }
  },
  methods: {
    async saveDate() {},
    upload() {
      document.getElementById("uploadImage_").click();
    },
    async onImageChange(e) {
      this.uploadImage_ = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.fileName = files[0].name;
      this.uploadImage();
    },
    async createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    async uploadImage() {
      const data = new FormData();
      data.append("image", this.uploadImage_);
      data.append("fileName", this.fileName);

      let axiosConfig = {
        headers: { "content-type": "multipart/form-data" }
      };

      const response = await axios
        .post(
          `${this.root}/laravel/public/api/v1/promoter/race/updateRaceImage/${this.$route.params.id}`,
          data,
          axiosConfig
        )
        .catch(
          function(error) {
            const status = error.response.status;

            switch (status) {
              case 401:
                window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
                break;
            }
          }.bind(this)
        );
      if (response.data.success == 1) {
        this.imageUrl =
          process.env.VUE_APP_ROOT + "/laravel/public/" + response.data.message;
      }else{
          this.msg = this.$t('dashboard.menu.raceDetails.alertFile');
          this.alertError = true;
      }
    },
    close(id) {
      this.menu_[id] = false;
    },
    async sendMessage(input) {
      this.menu_[input] = false;
    },
    async ImgError() {
      this.failed_image = false;
      this.imageUrl = require("@/assets/images/orgPlaceholder.jpg.png");
    },
    //saveDate() {},
    saveTime() {}
  }
};
</script>
